import React, { memo } from "react"
import PropTypes from "prop-types"
import Icon from "components/common/Icon"

import { useTranslation } from "react-i18next"

import { useSelector } from "react-redux"
import { numberToCurrency } from "helpers/string"
import { Card, Col, Flex, Row, Typography } from "antd"
import { Text } from "ui/Typography"

Widget.propTypes = {
  stats_name: PropTypes.string.isRequired,
  isCurrency: PropTypes.bool
}

Widget.defaultProps = {
  isCurrency: false
}

function Widget({ stats_name, isCurrency = false }) {
  const { t } = useTranslation()
  const { metadata } = useSelector((store) => store.accounting)
  const { current_month, monthly_diff = "", last_month, ytd } = metadata[`${stats_name}_stats`] || {}
  const monthlyDiffIsPositive = Number.parseFloat(monthly_diff.replaceAll(/[^0-9.-]+/g, "")) > 0

  return stats_name ? (
    <Card>
      <div>
        <h4 className="mb-3">{t(`accounting.labels.${stats_name}`)}</h4>
        <Row gutter={[30, 16]}>
          <Col xl={8} md={12} sm={24}>
            <Text className="block">{t("accounting.labels.this_month")}</Text>
            <Typography.Title level={4} className="m-0 pt-xxs">{isCurrency ? numberToCurrency(current_month) : current_month || "—"}</Typography.Title>
            <Flex gap={6} align="center" className={`${monthlyDiffIsPositive ? "text-success" : "text-danger"
              }`}>
              <Icon iconName={"ArrowDown"} className={monthlyDiffIsPositive ? "rotate-180" : ""} size={10} block />
              <Text className={`${monthlyDiffIsPositive ? "text-success" : "text-danger"
                }`}>
                {monthly_diff || "—"}
              </Text>
            </Flex>
          </Col>
          <Col xl={8} md={12} sm={24} className="border-r border-l">
            <div >
              <Text className="block">{t("accounting.labels.last_month")}</Text>
              <Typography.Title level={4} className="m-0 pt-xxs">{isCurrency ? numberToCurrency(last_month) : last_month || "—"}</Typography.Title>
            </div>
          </Col>
          <Col xl={8} md={12} sm={24}>
            <div>
              <Text className="block">{t("accounting.labels.year_to_date")}</Text>
              <Typography.Title level={4} className="m-0 pt-xxs">{isCurrency ? numberToCurrency(ytd) : ytd || "—"}</Typography.Title>
            </div>
          </Col>
        </Row>
      </div>
    </Card>
  ) : null
}

export default memo(Widget)
